import 'scss/services/semantic-dependence-graph.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'
import { config } from 'config'

initServiceOpen()
$(function () {
  $('.to-service-open').click(function () {
    showserviceOpenModal({}, {
      detailUrl: `${config.CONSOLE}/app/myapp`,
      appIdKey: 'keyword',
      needBase64: false
    })
  })
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/semantic-dependence-graph.js